import { IFeature } from 'mod/featureV2/interface';

export const backToTop: IFeature = {
    moduleId: 'backToTop',
    type: 'backToTop',
    space: {
        paddingTop: 64,
        paddingBottom: 64,
    },
};